import { GroupParams, OptOutParams } from './types';

export const contactsKeys = {
  all: () => ['contacts'] as const,
  lists: () => [...contactsKeys.all(), 'list'] as const, // list of all items
  list: (filters: string) => [...contactsKeys.lists(), { filters }] as const, // list of items with specific filters,
  details: () => [...contactsKeys.all(), 'detail'] as const, // all single items we visit
  detail: (conversationId: string) =>
    [...contactsKeys.details(), conversationId] as const, // single item,
  groups: (params: GroupParams) => ['groups', params] as const, // groups
  opt_out_list: (filters: OptOutParams) => ['opt_out', filters] as const,
};
